<template>
    <a-select v-model:value="tempValue" :options="options" allowClear style="min-width: 200px;"></a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, toRefs, watch } from "vue";

import { Select } from "ant-design-vue";
import { OptionType } from "ant-design-vue/lib/select";

import ApiRequest from "@/utils/ApiRequest";

enum ComponentEmits {
    UPDATE_MODEL_VALUE = 'update:modelValue',
}

export default defineComponent({
    components: {
        ASelect: Select,
    },

    props: {
        modelValue: Number,
    },

    emits: {
        [ComponentEmits.UPDATE_MODEL_VALUE]: Number,
    },

    setup(props, ctx) {
        const { modelValue: tempValue } = toRefs(props);
        const options = ref<OptionType[]>([]);

        onMounted(() => {
            ApiRequest.get('/servers')
                .then(response => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    options.value = response.data.data.map((server: any) => ({
                        value: server.id,
                        label: server.name,
                    }));
                });
        });

        watch(() => props.modelValue, (val) => {
            tempValue.value = val;
        });

        watch(() => tempValue.value, (val) => {
            ctx.emit(ComponentEmits.UPDATE_MODEL_VALUE, val);
        });

        return {
            tempValue,
            options,
        };
    },
});
</script>
